import Constants, { SLOT_IDS, OPTIONS_IDS } from '../data/Constants';

const initialState = {
  // coordinates of drop-zone layouts
  dropZoneLayouts: {
    [SLOT_IDS.HOME_1]: {},
    [SLOT_IDS.HOME_2]: {},
    [SLOT_IDS.HOME_3]: {},
    [SLOT_IDS.SUBMISSION_1]: {},
    [SLOT_IDS.SUBMISSION_2]: {},
  },
  // map beetween drop-zones and options
  dropZoneOptionIds: {
    [SLOT_IDS.SUBMISSION_1]: null,
    [SLOT_IDS.SUBMISSION_2]: null,
    [SLOT_IDS.HOME_1]: OPTIONS_IDS.OPTION_1,
    [SLOT_IDS.HOME_2]: OPTIONS_IDS.OPTION_2,
    [SLOT_IDS.HOME_3]: OPTIONS_IDS.OPTION_3,
  },
};

const slotLayoutsReducer = (state = initialState, action) => {
  if (action.gameId !== Constants.GAME_ID) {
    return state;
  }

  switch (action.type) {
    case 'INIT_ONBOARDING':
    case 'INIT_LEVEL':
      return initialState;
    case 'RESET_SLOTS':
      return {
        ...state,
        dropZoneOptionIds: { ...initialState.dropZoneOptionIds },
      };
    case 'SET_DROP_ZONE_LAYOUT':
      return {
        ...state,
        dropZoneLayouts: {
          ...state.dropZoneLayouts,
          [action.payload.dropZoneId]: action.payload.layout,
        },
      };

    case 'SET_DROP_ZONE_OPTION_ID':
      return {
        ...state,
        dropZoneOptionIds: {
          ...state.dropZoneOptionIds,
          [action.payload.dropZoneId]: action.payload.optionId,
        },
      };
    default:
      return state;
  }
};

export default slotLayoutsReducer;
